import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Problem } from "../components/Problem";
import { Services } from "../components/Services";
import { Portfolio } from "../components/Portfolio";
import { Manifesto } from "../components/Manifesto";
import { Benefits } from "../components/Benefits";
import { BeforeAfter } from "../components/BeforeAfter";
import { Testimonials } from "../components/Testimonials";
import { Faq } from "../components/Faq";
import { Seo } from "../components/Seo";
import { Pricing } from "../components/Pricing";
import { Contact } from "../components/Contact";
import { scrollToId } from "../lib/scroll";

export default function Home() {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const id = location.state?.scrollTo;
    if (id) setTimeout(() => scrollToId(id), 150);
  }, [location.state]);

  const onSelect = (id) => {
    setSelectedPackage(id);
    scrollToId("kontakt");
  };

  return (
    <main data-testid="home-page">
      <Seo
        title="KI-Produktbilder für Amazon & Onlineshops | Salgin Solutions"
        description="Professionelle KI-Produktbilder, Lifestyle-Szenen, technische Grafiken und Amazon A+ Content für Händler und Marken. Individuell erstellt, ab 7,50 € pro Bild. Salgin Solutions, Bad Oeynhausen."
        path="/"
      />
      <Hero />
      <Marquee />
      <Problem />
      <Services />
      <Portfolio />
      <BeforeAfter />
      <Manifesto />
      <Benefits />
      <Testimonials />
      <Pricing onSelect={onSelect} />
      <Faq />
      <Contact selectedPackage={selectedPackage} />
    </main>
  );
}
